import {JSX, useContext} from "react";
import {AuthContext} from "./context/AuthProvider";
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./routes/ProtectedRoute";
import PrivateLayout from "./layouts/PrivateLayout";
import PublicLayout from "./layouts/PublicLayout";
import {Projects} from "./pages/Projects";
import {Forms} from "./pages/Forms";
import {OrganizationPage} from "./pages/Organization";
import {useOrganization} from "./context/OrganizationContext";
import {AddUserPage} from "./pages/AddUser";

const App = (): JSX.Element => {
    const {isAuthenticated} = useContext(AuthContext);
    const {organizations, selectedOrganizationId} = useOrganization();
    const selectedOrganization = organizations.find(org => org._id === selectedOrganizationId);

    return (
        <BrowserRouter>
            <Routes>
                {/* Redirect iniziale */}
                <Route
                    path="/"
                    element={
                        isAuthenticated ? <Navigate to="/dashboard"/> : <Navigate to="/"/>
                    }
                />

                {/* Layout pubblico */}
                <Route element={<PublicLayout/>}>
                    {/* eventuali pagine pubbliche (login, register, ecc.) */}
                </Route>

                {/* Layout protetto */}
                <Route element={<ProtectedRoute isAuthenticated={isAuthenticated}/>}>
                    <Route element={<PrivateLayout/>}>
                        <Route path="/dashboard" element={<Dashboard/>}/>
                        <Route path="/projects" element={<Projects/>}/>
                        <Route path="/projects/:projectId" element={<Projects/>}/>
                        <Route path="/forms" element={<Forms/>}/>
                        <Route path="/forms/:formId" element={<Forms/>}/>

                        {/* 🔹 Nuova pagina Organization */}
                        <Route
                            path="/organization"
                            element={selectedOrganization ? (
                                <OrganizationPage organization={selectedOrganization}/>
                            ) : (
                                <p className="p-6 text-ink-muted">No organization selected.</p>
                            )}
                        />
                        <Route path="/organization/add-user" element={<AddUserPage/>}/>
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default App;
